/**
* @Description 文件功能说明：单选框-树操作
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div :ref="subRef" @mousedown="mouseDownSub" @mouseup="mouseUpSub">
        <el-input
            :ref="inpRef"
            :style="{'width': width}"
            v-model="showParam"
            :placeholder="selectTree.placeholder"
            readonly
            @click.native="handleInput"
            @blur="blurInput"
            :suffix-icon="icon"
        >
        </el-input>
        <div style="position:fixed;z-index: 3333;" v-show="treeShowFlag">
            <div class="aaa"></div>
            <div class="numberScreening" :style="{'min-width': width}">
               <div style="display:flex;flex-direction:row;" class="traceScreeningMb" v-if="selectTree.keywordFilter">
                   <el-input
                        placeholder="输入关键字进行回车过滤"
                        v-model="filterText"
                        class="inputBg"
                        :style="{'min-width': width}"
                        @keyup.enter.native="handleSearch"
                    ></el-input>
               </div>
                <el-button type="text" :class="{'on': emptySelectParam}" :style="{'padding-left': '24px','padding-right': '24px','text-align': 'left','font-size': '14px','font-weight': 'bold'}" @click="resetSelect" trigger="click" v-if="selectTree.placeholder != ''">{{selectTree.placeholder}}</el-button>
                <el-tree
                    class="numberScreeningTree"
                    :data="data"
                    highlight-current
                    :props="defaultProps"
                    :default-expand-all="true"
                    :expand-on-click-node="false"
                    ref="tree"
                    node-key="id"
                    :check-strictly="strictly"
                    @node-click="handleTreeNode"
                    :filter-node-method="filterNode"
                    :show-checkbox="showBox"
                    @check="selectBox"
                >
                    <template v-slot="{node, data}">
                        <span class="custom-tree-node" >
                        <span class="tree-label">{{data.label}}</span>
                    </span>
                    </template>
                </el-tree>
                <el-button type="text" size="mini" @click="()=>{selectNode()}" v-if="showBox" trigger="click" style="margin-top:10px; padding-right: 10px;text-align: right;font-size: 14px;">确定选项</el-button>
            </div>
        </div>
    </div>
</template>

/* JS */
<script>
    export default {
        /**
        * @Des 组件名
        * @Auth CC
        * @Date 2021/04/30
        */
        name: "TreeSingleItem",
        /**
        * @Des 接收数据
        * @Auth CC
        * @Date 2021/04/30
        */
        props:{
            data: Array,
            selectTree: Object,
            showBox:{
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            strictly:{
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            width:{
                type: String,
                default: function() {
                    return '200px';
                }
            },
            inpRef:{
                type: String,
                default: function() {
                    return 'selectTreeInp_' + new Date().getTime();
                }
            },
            subRef: {
                type: String,
                default: function() {
                    return 'selectTreeSub_' + new Date().getTime();
                }
            },
        },
        data(){
            return {
                // 是否展示树结构
                treeShowFlag: false,
                // 下拉框参数
                selectParam: {},
				// 展示参数
                showParam: '',
                filterText: "",
                icon: "el-icon-arrow-down",
                // 默认属性
                defaultProps: {
                    label: 'label',
                    children: 'children'
                },
                // 计时器 blur
                timer_blur: null,
                // 计时器 down sub
                timer_down_sub: null,
            }
        },
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 关闭 timer
        	this.endTimers();
		},// beforeDestroy
		mounted() {
			
		},
        methods: {
			// 关闭 timers
			endTimers() {
				// 清除计时器 blur
				if (this.timer_blur != null) {
					clearTimeout(this.timer_blur);
					this.timer_blur = null;
				}
				// 清除计时器
				if (this.timer_down_sub != null) {
					clearInterval(this.timer_down_sub);
					this.timer_down_sub = null;
				}
			},
			/**
			 * @Des 鼠标按下
			 * @Auth 
			 * @Date 
			 */
			mouseDownSub() {
				// 清除计时器
				if (this.timer_down_sub != null) {
					clearInterval(this.timer_down_sub);
					this.timer_down_sub = null;
				}
				let time = new Date().getTime();
				// 计时器 down sub
				this.timer_down_sub = setInterval(() => {
					let _time = new Date().getTime();
					
					// 清除计时器
					if (this.timer_blur != null) {
						clearInterval(this.timer_down_sub);
						clearTimeout(this.timer_blur);
						this.timer_blur = null;
						return false;
					}
					
					// 超时 中止
					if (_time - time > 5*50) {
						clearInterval(this.timer_down_sub);
						return false;
					}
				}, 50);
			},// mouseDownSub
			/**
			 * @Des 鼠标抬起
			 * @Auth 
			 * @Date 
			 */
			mouseUpSub() {
				// 清除计时器
				if (this.timer_down_sub != null) {
					clearInterval(this.timer_down_sub);
					this.timer_down_sub = null;
				}
			},// mouseUpSub
			/**
			 * @Des 下拉框失去焦点
			 * @Auth 
			 * @Date 
			 */
			blurInput() {
				// 清除计时器
				if (this.timer_blur != null) {
					clearTimeout(this.timer_blur);
					this.timer_blur = null;
				}
				// 已关闭 中止
				if (!this.treeShowFlag) return false;
				this.timer_blur = setTimeout(() => {
					this.treeShowFlag = false;
					this.icon = "el-icon-arrow-down";
					if (this.timer_blur != null) {
						clearTimeout(this.timer_blur);
						this.timer_blur = null;
					}
				}, 200);
			},
            /**
            * @Des 点击下拉框
            * @Auth CC
            * @Date 2021/04/30
            */
            handleInput(event) {
                this.treeShowFlag = !this.treeShowFlag;
                if (this.treeShowFlag) {
                    this.icon = "el-icon-arrow-up";
                    // input 获取焦点
                    this.$refs[this.inpRef].focus();
                } else {
                    this.icon = "el-icon-arrow-down";
                }
                this.filterText = '';
            },
            /**
			* @Des 搜索
			* @Auth CC
			* @Date 2021/04/30
			*/
            handleSearch() {
                this.$refs.tree.filter(this.filterText);
            },
            /**
			* @Des 点击树节点
			* @Auth CC
			* @Date 2021/04/30
			*/
            handleTreeNode(row) {
                // console.log(this.showBox, row)
                if(this.showBox){
                    let currentNode = this.$refs.tree.getNode(row.id);
                    this.$refs.tree.setChecked(row.id, !currentNode.checked);
                    // if(row.type == 2){
                    // }else{
                    //     this.$refs.tree.setChecked(row.id, false);
                    // }
                }else{
                    this.selectParam = row;
                    this.showParam = row.label;
                    this.treeShowFlag = false;
                    this.resetIcon();
                    this.$emit('setSelectVal', this.selectParam);
                }
            },
            /**
			* @Des 过滤树节点
			* @Auth CC
			* @Date 2021/04/30
			*/
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            /**
			* @Des 重置选中状态
			* @Auth CC
			* @Date 2021/04/30
			*/
            resetSelect(){
                this.selectParam = {};
                this.showParam = '';
                this.resetIcon();
                // 父级选中回调
                this.$emit('setSelectVal', this.selectParam);
            },
            setSelectVal(val){
                this.$nextTick(() => {
                    if(val){
                        this.selectParam = val;
                        this.showParam = val.label;
                        // 默认高亮
                        this.$refs.tree.setCurrentKey(val.id);
                    }else{
                        this.selectParam = {};
                        this.showParam = '';
                    }
                    this.resetIcon();
                })
            },
            setSelectMoreVal(ids, names){
                this.$nextTick(() => {
                    let nodes = this.$refs.tree.getCheckedNodes();
                    // console.log(nodes);
                    for(let i=0;i<nodes.length;i++){
                        this.$refs.tree.setChecked(nodes[i].id, false);
                    }
                    if(ids && names){
                        this.showParam = names.join(",");
                        for(let i=0;i<ids.length;i++){
                            let currentNode = this.$refs.tree.getNode(ids[i]);
                            this.$refs.tree.setChecked(ids[i], true);
                        }
                    }else{
                        this.selectParam = {};
                        this.showParam = '';
                    }
                    this.resetIcon();
                })
            },
            /**
			* @Des 关闭子节点
			* @Auth CC
			* @Date 2021/04/30
			*/
            resetIcon(){
                this.treeShowFlag = false;
                this.icon = "el-icon-arrow-down";
            },
            /**
             * @Des 获取选中节点数据
             * @Auth jsh
             * @Date 2021/07/2
             */
            selectNode() {
                let nodes = this.$refs.tree.getCheckedNodes();
                // console.log(nodes)
                this.$emit('setSelectVal', nodes);
            },
            /**
             * 选择框
             */
            selectBox(row){
                let currentNode = this.$refs.tree.getNode(row.id);
                if(row.type == 1){
                    // this.$refs.tree.setChecked(row.id, false);
                }
            }
        },
        // 计算属性
        computed: {
        	// 判断值为空
            emptySelectParam: function () {
            	return this.$checkEmpty(this.selectParam);
            }
        }

    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/TreeSingleSelect.vue